export default __webpack_public_path__ + "static/media/popup-3.adc56c61.png";